import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface BraintreeProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const BraintreeConfigurationCard = ({ processor }: BraintreeProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null

    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Braintree Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Merchant ID</p>
                        <p className="font-mono text-sm">{options?.merchantId || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Public Key</p>
                        <p className="font-mono text-sm">{options?.publicKey || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Private Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Sandbox' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const BraintreeProcessorDetailsPage = ({ processor }: BraintreeProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="braintree" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <BraintreeConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
